import React,{useState} from 'react';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button } from './css';
const Locked = ({orderData}) => {

  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { locked },
  } = localizedStrings; 
  return (
    <>
      <Button disabled>Locked</Button>
      
    </>
  );
};

export default Locked;
